var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.xaxis.categories && _vm.series[0])?_c('div',{staticClass:"ma-1"},[_c('VueApexCharts',{attrs:{"height":"420px","type":"heatmap","options":_vm.options,"series":_vm.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }